/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileDetailsHourRange
 */
export interface StoreProfileDetailsHourRange {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileDetailsHourRange
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileDetailsHourRange
     */
    to: string;
}

/**
 * Check if a given object implements the StoreProfileDetailsHourRange interface.
 */
export function instanceOfStoreProfileDetailsHourRange(value: object): value is StoreProfileDetailsHourRange {
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function StoreProfileDetailsHourRangeFromJSON(json: any): StoreProfileDetailsHourRange {
    return StoreProfileDetailsHourRangeFromJSONTyped(json, false);
}

export function StoreProfileDetailsHourRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileDetailsHourRange {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'],
        'to': json['to'],
    };
}

export function StoreProfileDetailsHourRangeToJSON(json: any): StoreProfileDetailsHourRange {
    return StoreProfileDetailsHourRangeToJSONTyped(json, false);
}

export function StoreProfileDetailsHourRangeToJSONTyped(value?: StoreProfileDetailsHourRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
        'to': value['to'],
    };
}

